import { Box, LinearProgress, styled } from "@mui/material";
import { P } from "../Typography";
import { gray50 } from "../../theme";

const LinearProgressStyled = styled(LinearProgress)(({ theme }) => ({
  minHeight: 8, // shrinked to 0 by flex when overflows to scroll
  height: 8,
  borderRadius: 4,
  backgroundColor: gray50,
}));

export function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box sx={{ width: "100%" }}>
        <LinearProgressStyled variant="determinate" {...props} />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <P>{`${Math.round(props.value)}%`}</P>
      </Box>
    </Box>
  );
}
